import { DownOutlined } from "@ant-design/icons";
import { Logo, VideoBackground } from "@bodhistreams/ui";
import { Button, Typography, theme } from "antd";
import PageLayout from "./PageLayout";

const { Title, Paragraph } = Typography;
const { useToken } = theme;

const ContactHero = () => {
	const { token } = useToken();

	const scrollToNextSection = () => {
		const heroHeight = window.innerHeight;
		window.scrollTo({
			top: heroHeight,
			behavior: "smooth",
		});
	};

	return (
		<div style={{ position: "relative" }}>
			<VideoBackground
				showBlueGradient={false}
				showTopWhiteGradient={false}
				showBottomWhiteGradient={false}
				showVerticalGradient={true}
				darkOverlayOpacity="rgba(0, 0, 0, 0.1)"
				containerStyle={{
					padding: "40px 24px",
					textAlign: "center",
					height: "100vh",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					marginBottom: "40px",
				}}
				contentStyle={{
					maxWidth: "800px",
				}}
			>
				<div style={{ maxWidth: "800px", position: "relative", zIndex: 1 }}>
					<Logo.Favicon hyperlink={true} size={80} />
					<Title
						style={{
							marginTop: "20px",
							marginBottom: "24px",
							color: token.colorText,
						}}
					>
						Contact Us
					</Title>
					<Paragraph
						style={{
							fontSize: "16px",
							marginBottom: "24px",
							maxWidth: "600px",
							margin: "0 auto 24px",
							color: token.colorTextSecondary,
						}}
					>
						For more information about our services or to get in touch, feel
						free to drop us a line at info@bodhistreams.com. We'd love to hear
						from you and are happy to answer any questions you may have.
					</Paragraph>
				</div>
			</VideoBackground>

			{/* Scroll arrow positioned absolutely relative to the Hero container */}
			<Button
				type="text"
				icon={<DownOutlined />}
				onClick={scrollToNextSection}
				style={{
					position: "absolute",
					bottom: "80px", // Adjusted to account for marginBottom
					left: "50%",
					transform: "translateX(-50%)",
					fontSize: "24px",
					height: "48px",
					width: "48px",
					borderRadius: "50%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					color: token.colorTextTertiary,
					backgroundColor: "transparent",
					zIndex: 10,
				}}
			/>
		</div>
	);
};

const Contact = () => {
	return (
		<PageLayout fullWidthContent={<ContactHero />}>
			{/* Empty content section since all content is now in the Hero */}
		</PageLayout>
	);
};

export default Contact;
